module.exports = __webpack_public_path__ + "img/2-tr.8eb23d81.jpg";